import { tv } from "tailwind-variants";
import React from "react";

const styles = tv({
  slots: {
    base: [
      "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-0 border-transparent transition-colors duration-100 ease-in-out ",
    ],
    knob: [
      "pointer-events-none inline-block size-6 transform rounded-full bg-white shadow ring-0 transition duration-300 ease-in-out",
    ],
  },
  variants: {
    enabled: {
      true: {
        base: "bg-green-light/50",
        knob: "translate-x-full",
      },
      false: {
        base: "bg-gray-200",
        knob: "translate-x-0",
      },
    },
  },
  defaultVariants: {
    enabled: false,
  },
});

interface ToggleProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  enabled?: boolean;
  onToggle: (value: boolean) => void;
}

const Toggle = ({
                  enabled = false,
                  onToggle,
                  ...rest
                }: ToggleProps) => {

  const { base, knob } = styles({ enabled: enabled });

  const onClick = () => {
    onToggle(!enabled);
  };

  return (

    <div className="flex items-center">
      <div className="flex items-center gap-4">
        {!enabled && <span className="pr-2">OFF</span>}
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          onClick={onClick}
          className={base()}
          {...rest}
        >
          <span className={knob()} />
        </button>
        {enabled && <span className="pl-2">ON</span>}
      </div>
    </div>
  )
};

export default Toggle;
